////////LIBRARY/////////
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { isEmpty, isUndefined, map, cloneDeep, reject, find } from 'lodash'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import ListEditable from '../../../components/ListEditable'
import { tagsManagerActionCreators } from '../../../store/actions'
import Tooltip from '../../../components/Tooltip/Tooltip'
import ToggleFilters from '../../../components/Ui/ToggleFilters'
import {
	PageGridTitle,
	PageGridBorder,
	CreateButton,
	SearchInputWrapper,
	SearchInputButton,
	InputLogin,
	SelectInputWrapper,
	SelectInput,
	SearchReset,
} from '../../../theme/GlobalCss'
import userPrivileges from '../../../constants/PrivilegesList'
import TooltipHelp from '../../../components/TooltipHelp'
/////////ASSETS/////////
import PrivateTagIcon from '../../../assets/icones/global/thumb-black.svg'
import PrivateTagIconSelected from '../../../assets//icones/global/thumb-white.svg'

//////STYLED//////
const TagsListManagerWrapper = styled.div`
	position: relative;
`
const ListActions = styled.div`
	position: relative;
	padding: 10px;
	display: flex;
	flex-direction: row;
`
const TagsSearchWrapper = styled.div`
	position: relative;
	& > * > input {
		font-size: ${(props) => props.theme.font.fs};
	}
`
const TagTypeWrapper = styled.div`
	margin-right: 26px;
	& > * > select {
		font-size: ${(props) => props.theme.font.fs};
	}
`
//////STYLED//////

const TagsListManager = (props) => {
	const [sortDir, setSortDir] = useState(1) // asc by default
	const [searched, setSearched] = useState('')
	const [searchValue, setSearchValue] = useState('')
	const [tagTypeSelected, setTagTypeSelected] = useState(0)
	const [sortColumnName, setSortColumnName] = useState('name')

	const refListTags = useRef()

	const { translations, tagsManager, user } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			tagsManager: state.tagsManager,
			user: state.user,
		}),
		shallowEqual
	)

	const [inputData, setInputData] = useState()

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleInputData = () => {
		let newinputData = cloneDeep(tagsManager.items)

		const current_tag_type = config.filters.tagType

		switch (current_tag_type) {
			case '1':
				newinputData = reject(newinputData, (o) => {
					return !o.isPrivate ? false : true
				})
				break
			case '2':
				newinputData = reject(newinputData, (o) => {
					return o.isPrivate ? false : true
				})
				break
			default:
				break
		}

		if (searchValue.length > 0) {
			newinputData = reject(newinputData, (o) => {
				/*const str = (o.name).toUpperCase()
                return str.includes(searchValue.toUpperCase()) ? false : true*/

				let str = cloneDeep(o.name)
				str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
				let transformed_search = cloneDeep(searchValue)
				transformed_search = transformed_search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
				return str.toUpperCase().includes(transformed_search.toUpperCase()) ? false : true
			})
		}

		setInputData(newinputData)
	}

	const handleTagTypeSelected = (e) => {
		setTagTypeSelected(e.target.value)
	}

	const handleSearchValue = (e) => {
		setSearchValue(e.target.value)
	}

	const handleSearch = (e) => {
		setSearched(searchValue)
	}

	const handleSearchEnter = (e) => {
		if (e.keyCode === 13 || searchValue === '') setSearched(searchValue)
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: translations['page__tagManagement__tag_list'],
		filters: {
			tagType: tagTypeSelected,
			searchValue: searched,
		},
		tagTypes: [
			{ value: 0, label: translations['common__text__all'] },
			{ value: 1, label: translations['page__tagManagement__tag_type_public'] },
			{ value: 2, label: translations['page__tagManagement__tag_type_private'] },
		],
		listEditableMarker: {
			translationsKey: 'tooltip__admin__tagManagement__typeOfTag',
			tooltipId: 'privateTag',
		},
	}

	const columns = [
		// We set what data value is used to
		// For setting value of input
		{ isRadioValue: true, dataHook: 'id', headerName: 'id', sortable: false },
		{ hasMarker: true, icon: PrivateTagIcon, iconSelected: PrivateTagIconSelected, dataHook: 'isPrivate' },
		// For labelling the item
		{ isLabel: true, dataHook: 'name', headerName: 'name', sortable: true, alreadyTranslated: true, usingMarker: 'isPrivate' },
		// We could setup fields uses for edit / delete checking here !s
		{
			isActions: !isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[12])) ? true : false,
			dataHook: 'isPrivate',
		},
	]

	const actionsTagsManager = bindActionCreators(tagsManagerActionCreators, useDispatch())

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!isEmpty(translations)) {
			actionsTagsManager.getTags()
		}
	}, [translations])

	useEffect(() => {
		if (!isEmpty(tagsManager.items)) {
			// Refreshing display
			setInputData(tagsManager.items)
			refListTags.current = tagsManager.items
		} else {
			refListTags.current = tagsManager.items
			setInputData([])
		}
	}, [tagsManager.items])

	useEffect(() => {
		// Whenever we change filters, we redraw the list
		handleInputData()
	}, [tagTypeSelected, searched])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TagsListManagerWrapper>
			<TooltipHelp content={'tooltipHelp__admin__modal__body__tagManagement_user__tagList'} insideModal>
				<PageGridTitle>{config.name}</PageGridTitle>
			</TooltipHelp>
			<PageGridBorder>
				<ListActions>
					<TagsSearchWrapper>
						<SearchInputWrapper>
							<InputLogin
								value={searchValue}
								onChange={handleSearchValue}
								onKeyDown={handleSearchEnter}
								placeholder={translations['page__tagManagement__tag_search']}
							/>
							<SearchInputButton onClick={handleSearch} />
						</SearchInputWrapper>
					</TagsSearchWrapper>
					{searchValue.length > 0 && (
						<SearchReset
							onClick={() => {
								setSearchValue('')
								setSearched('')
							}}
						/>
					)}
					{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[12])) && (
						<Tooltip tooltipId={'tagListAdd'} translationsKey={'tooltip__admin__tagManagement__createTag'}>
							<CreateButton onClick={() => props.showCreationModal()} />
						</Tooltip>
					)}
				</ListActions>
				<ListActions>
					<TagTypeWrapper>
						<SelectInputWrapper blueColor>
							<SelectInput width="145" onChange={handleTagTypeSelected}>
								{map(config.tagTypes, (elem, id) => {
									return (
										<option key={id} value={elem.value}>
											{elem.label}
										</option>
									)
								})}
							</SelectInput>
						</SelectInputWrapper>
					</TagTypeWrapper>
					<ToggleFilters
						checked={sortDir}
						onChangeHandler={() => {
							setSortDir(sortDir === 0 ? 1 : 0)
						}}
						name="columnSort"
						labelPrev="AZ"
						labelNext="ZA"
						reverseCheck
					/>
				</ListActions>
				<ListEditable
					inputData={inputData}
					inputColumns={columns}
					type="checkbox"
					translationMode={true}
					sortColumnName={sortColumnName}
					sortDir={sortDir}
					editMethod={props.showCreationModal}
					deleteMethod={props.showDeleteModal}
					listSelected={props.listSelected}
					currentListSelected={props.currentListSelected}
					ref={refListTags}
					sizeHeightActions={372}
					precheckedList={props.currentListSelected}
					config={config}
				/>
			</PageGridBorder>
		</TagsListManagerWrapper>
	)
}

TagsListManager.propTypes = {}

TagsListManager.defaultPropTypes = {}

export default TagsListManager
